import { useCallback, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Box,
  Container,
  Grid,
  Button,
  Typography,
  CardContent,
  Divider,
} from "@material-ui/core";

import PeriodField from "components/_refactor/fields/period-field";

import ClearButton from "components/_refactor/button/clear";
import HeaderClientes from "components/_refactor/headers/clients";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import DialogMonitorDeTeares from "components/Dialogs/DialogMonitorDeTeares";
import BignumbersLoomsFailures from "components/Bignumbers/BignumbersLoomsFailures";
import componentStyles from "assets/theme/components/cards/sortable/card-light-table-sortable";
import Api from "lib/api/httpRequestHelper";
import TableMonitorTeares from "./table/TableMonitorTeares";
import LoadingData from "components/Loading/LoadingData";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import { IsMobile900, IsMobile } from "utils/is-mobile";

const useStyles = makeStyles(componentStyles);
const useCardStyles = makeStyles(() => ({
  blueBg: {
    backgroundColor: "#2069E1",
  },
  greenBg: {
    backgroundColor: "#60C753",
  },
  redBg: {
    backgroundColor: "#CA2C0C",
  },
  fullScreen: {
    height: "100vh",
    position: "absolute",
    left: 0,
    width: "100vw",
    overflow: "hidden",
  },
}));

const failureSituationData = [
  {
    value: "PENDENTES",
    name: "Pendentes",
  },
  {
    value: "RESOLVIDAS",
    name: "Resolvidas",
  },
  {
    value: "TODAS",
    name: "Todas",
  },
];

const failurePeriodData = [
  {
    value: "LANCAMENTO",
    name: "Lançamento",
  },
  {
    value: "RESOLUCAO",
    name: "Resolução",
  },
];

function MonitorDeTeares() {
  const classes = useStyles();
  const bgColors = useCardStyles();
  const snackbar = useSnackbar();

  const [failuresDataTotal, setFailuresDataTotal] = useState(null);
  const [failuresDataResolved, setFailuresDataResolved] = useState(null);
  const [failuresDataPending, setFailuresDataPending] = useState(null);
  const [showFilters, setShowFilters] = useState(false);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRegisters, setTotalRegisters] = useState(0);
  const [currentPage, setCurrentPage] = useState(null);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(null);
  const [showRows, setShowRows] = useState(false);
  const [hasUpdated, setHasUpdated] = useState(false);
  const [hasUpdatedBigNumber, setHasUpdatedBigNumber] = useState(false);
  const [typeFailure, setTypeFailure] = useState("PENDENTES");
  const [reasonsFailure, setReasonsFailure] = useState([]);
  const [reasonId, setReasonId] = useState("");
  const [situation, setSituation] = useState(failureSituationData[0]);
  const [period, setPeriod] = useState(failurePeriodData[0]);
  const [registerPeriod, setRegisterPeriod] = useState(null);
  const [initialDate, setInitialDate] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [searchingFailures, setSearchingFailures] = useState(false);
  const [finalDate, setFinalDate] = useState();
  const [failuresDataTable, setFailuresDataTable] = useState([]);
  const [failureDetail, setFailureDetail] = useState(null);
  const [failuresCell, setFailuresCell] = useState([]);
  const [failureCell, setFailureCell] = useState("");
  const [typeProcessingList, setTypeProcessingList] = useState([]);
  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [selectedReason, setSelectedReason] = useState(null);
  const [searching, setSearching] = useState(true);
  const [fullScreen, setFullScreen] = useState(false);
  const [clearFilters, setClearFilters] = useState(false);
  const [cancelLoading, setCancelLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const toggleFormDialog = useCallback((formType) => {
    if (formType) {
      setOpenFormDialog(formType);
    }
  }, []);

  const isMobile900 = IsMobile900();

  const isMobile700 = IsMobile();

  const itemXS3 = isMobile700 ? 12 : isMobile900 ? 6 : 3;

  const handleGetFailuresList = useCallback(
    async (e, page = 1, pageSize = 25) => {
      setCancelLoading(false);
      setSearching(true);
      setSearchingFailures(false);
      setHasUpdatedBigNumber(false);

      const hasCell = failureCell ? `&celula=${failureCell.cell}` : "";
      const hasType = typeFailure ? `filtraGrupo=${typeFailure}&` : "";

      try {
        const res = await Api.get(
          `weave-register-list?${hasType}page=${page - 1}&pageSize=${
            pageSize ? pageSize : 25
          }&idMotivo=${reasonId ? reasonId.IdMotivoFalha : ""}&situacao=${
            situation.value
          }&tipoPeriodo=${
            period.value
          }&dtIni=${initialDate}&dtFim=${finalDate}${hasCell}`,
          "weave",
          "",
          true
        );
        setFailuresDataTable(res.Result.ListaLancamentoFalhas || []);
        setTotalPages(res.Result.TotalPaginas);
        setTotalRegisters(res.Result.TotalRegistro);
        setSearching(false);
      } catch (error) {
        setSearching(false);
        setShowRows(false);
        setErrorMessage(true);
        console.log(error);      } finally {
        setCurrentPage(page);
        setCurrentSizePerPage(pageSize);
        setSearching(false);
        setHasUpdated(false);
      }
    },
    [
      typeFailure,
      situation,
      reasonId,
      period,
      failureCell,
      registerPeriod,
      initialDate,
      finalDate,
    ]
  );

  const getFailuresBigNumbers = async () => {
    setCancelLoading(false);
    if (typeFailure === "") {
      setTypeFailure("PENDENTES");
    }

    try {
      const res = await Api.get(
        "weave-total-register-group",
        "weave",
        "",
        true
      );
      if (
        res.Result.TotalFalha !== failuresDataTotal ||
        res.Result.TotalFalhaResolvidas !== failuresDataResolved ||
        res.Result.TotalFalhaPendentes !== failuresDataPending
      ) {
        if (!hasUpdated) {
          setHasUpdatedBigNumber(true);
        }
        setFailuresDataTotal(res.Result.TotalFalha);
        setFailuresDataResolved(res.Result.TotalFalhaResolvidas);
        setFailuresDataPending(res.Result.TotalFalhaPendentes);
      }
    } catch (error) {
      console.log(error);    }
  };

  const getReasons = async () => {
    setSearching(true);

    try {
      const res = await Api.get("weave-fail-motive-list", "weave", "", true);
      setReasonsFailure(res.Result || []);
      setSearching(false);
    } catch (error) {
      console.log(error);
      setSearching(false);    }
  };

  const getCells = async () => {
    setSearching(true);
    try {
      const res = await Api.get("weave-cell-list", "weave", "", true);
      const cells = res.Result;
      const cellsList = [];
      cells?.map((cell) => {
        const newCell = {
          cell: cell.Celula.toString(),
          id: cell.Celula,
        };
        return cellsList.push(newCell);
      });
      setFailuresCell(cellsList || []);
      setSearching(false);
    } catch (error) {
      console.log(error);
      setSearching(false);    }
  };

  const getTypeCorrectionList = async () => {
    setSearching(true);
    try {
      const res = await Api.get(
        "weave-type-correction-list",
        "weave",
        "",
        true
      );
      setTypeProcessingList(res.Result || []);
      setSearching(false);
    } catch (error) {
      console.log(error);
      setSearching(false);    }
  };

  const getFailureDetail = async (failureID) => {
    setSearching(true);
    try {
      const res = await Api.get(
        `weave-register-detail?idLancamentoFalha=${failureID}`,
        "weave",
        "",
        true
      );
      setFailureDetail(res.Result || []);
      setSearching(false);
    } catch (error) {
      console.log(error);
      setSearching(false);    }
  };

  const tableData = () => {
    return (
      <div
        id="#fullscreenTableMonitorTeares"
        style={{ backgroundColor: "#fff" }}
      >
        {!searching && failuresDataTable?.length !== 0 && !cancelLoading ? (
          <div>
            <TableMonitorTeares
              setSelectedReason={setSelectedReason}
              toggleFormDialog={toggleFormDialog}
              showRows={showRows}
              dataTable={failuresDataTable}
              totalRegistros={totalRegisters}
              currentPage={currentPage}
              currentSizePerPage={currentSizePerPage}
              searchFailures={handleGetFailuresList}
              fullScreen={fullScreen}
              setFullScreen={setFullScreen}
            />
          </div>
        ) : (
          <>
            <LoadingData
              searching={searching}
              onClick={() => handleStopSearching()}
              label="Buscando dados..."
            />
          </>
        )}
      </div>
    );
  };

  const handleClearFilters = () => {
    setClearFilters(true);
    setTypeFailure("PENDENTES");
    setSituation(failureSituationData[0]);
    setPeriod(failurePeriodData[0]);
    setFinalDate();
    setInitialDate(new Date().toISOString().slice(0, 10));
    setRegisterPeriod(30);
    setFailureCell("");
    setReasonId("");
  };

  const handleStopSearching = () => {
    setCancelLoading(true);
    setSearching(false);
    setFailuresDataTable([]);
  };

  useEffect(() => {
    if (errorMessage && !cancelLoading) {
      snackbar.showMessage(
        "Ocorreu um erro ao buscar as falhas. Verifique os parâmetros informados e/ou tente novamente mais tarde.",
        {
          severity: "error",
        }
      );
    }
  }, [cancelLoading, errorMessage]);

  useEffect(() => {
    if (clearFilters && reasonId === "") {
      setClearFilters(false);
    }
  }, [reasonId, clearFilters]);

  useEffect(() => {
    if (selectedReason) {
      getFailureDetail(selectedReason.IdLancamentoFalha);
    }
  }, [selectedReason]);

  useEffect(() => {
    setInterval(() => {
      getFailuresBigNumbers();
    }, 60000);
  }, []);

  useEffect(() => {
    if (hasUpdated) {
      getFailuresBigNumbers();
      handleGetFailuresList();
    }
  }, [hasUpdated]);

  useEffect(() => {
    if (hasUpdatedBigNumber) {
      handleGetFailuresList();
    }
  }, [hasUpdatedBigNumber]);

  useEffect(() => {
    if (
      typeFailure === "TODOS" ||
      typeFailure === "RESOLVIDOS" ||
      typeFailure === "PENDENTES"
    ) {
      handleGetFailuresList();
    }
  }, [typeFailure]);

  useEffect(() => {
    if (searchingFailures) {
      handleGetFailuresList();
    }
  }, [searchingFailures]);

  useEffect(() => {
    if (failuresDataTable) {
      tableData();
    }
  }, [failuresDataTable, totalPages, totalRegisters]);

  useEffect(() => {
    getFailuresBigNumbers();
    handleGetFailuresList();
    getReasons();
    getCells();
    getTypeCorrectionList();
  }, []);

  return (
    <>
      <HeaderClientes section="Monitor de Teares" subsection="Tecelagem" />
      <Container style={{ marginTop: "-4.5rem" }} maxWidth={false}>
        <Grid container spacing={2}>
          <Grid
            item
            xs={isMobile700 ? 12 : 4}
            style={{ cursor: "pointer" }}
            onClick={() => setTypeFailure("TODOS")}
          >
            <BignumbersLoomsFailures
              bigNumberLoom
              label="Total de Falhas"
              value={failuresDataTotal}
              icon="fa fa-exclamation-triangle"
              bgColorIcon={bgColors.blueBg}
            />
          </Grid>
          <Grid
            item
            xs={isMobile700 ? 12 : 4}
            style={{ cursor: "pointer" }}
            onClick={() => setTypeFailure("RESOLVIDOS")}
          >
            <BignumbersLoomsFailures
              bigNumberLoom
              label="Falhas Resolvidas"
              value={failuresDataResolved}
              icon="fa fa-check"
              bgColorIcon={bgColors.greenBg}
            />
          </Grid>
          <Grid
            item
            xs={isMobile700 ? 12 : 4}
            style={{ cursor: "pointer" }}
            onClick={() => setTypeFailure("PENDENTES")}
          >
            <BignumbersLoomsFailures
              bigNumberLoom
              label="Falhas Pendentes"
              value={failuresDataPending}
              icon="fa fa-clock"
              bgColorIcon={bgColors.redBg}
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12} style={{ marginBottom: "0rem" }}>
            <Card classes={{ root: classes.cardRoot }}>
              <CardContent>
                <Typography
                  variant="h2"
                  component={Box}
                  style={{ marginBottom: "1.5rem" }}
                  onClick={() => setShowFilters(!showFilters)}
                >
                  Filtros
                  {showFilters ? (
                    <i
                      className="fa fa-angle-up"
                      aria-hidden="true"
                      style={{ marginLeft: "10px" }}
                    />
                  ) : (
                    <i
                      className="fa fa-angle-down"
                      aria-hidden="true"
                      style={{ marginLeft: "10px" }}
                    />
                  )}
                </Typography>
                <Grid container spacing={2} hidden={showFilters}>
                  <Grid item xs={itemXS3}>
                    <AutoCompleteField
                      label="Motivo"
                      loading={clearFilters}
                      onChange={setReasonId}
                      value={reasonId}
                      options={reasonsFailure}
                      disabled={searching}
                      optionLabelKey="DescMotivoFalha"
                      optionIdKey="IdMotivoFalha"
                    />
                  </Grid>
                  <Grid item xs={itemXS3}>
                    <AutoCompleteField
                      label="Situação"
                      loading={searching}
                      onChange={setSituation}
                      value={situation}
                      options={failureSituationData}
                      disabled={searching}
                      optionLabelKey="name"
                      optionIdKey="value"
                    />
                  </Grid>
                  <Grid item xs={itemXS3}>
                    <AutoCompleteField
                      label="Tipo de Período"
                      loading={searching}
                      onChange={setPeriod}
                      value={period}
                      options={failurePeriodData}
                      disabled={searching}
                      optionLabelKey="name"
                      optionIdKey="value"
                    />
                  </Grid>
                  <Grid item xs={itemXS3}>
                    <AutoCompleteField
                      label="Célula"
                      loading={clearFilters}
                      onChange={setFailureCell}
                      value={failureCell}
                      options={failuresCell}
                      disabled={searching}
                      optionLabelKey="cell"
                      optionIdKey="id"
                    />
                  </Grid>
                  {showFilters && <Divider />}
                  {!showFilters && (
                    <Grid
                      item
                      xs={registerPeriod?.value === "Outros" ? "12" : itemXS3}
                    >
                      <PeriodField
                        label="Período de registro"
                        value={registerPeriod}
                        onChange={setRegisterPeriod}
                        initialDate={initialDate}
                        finalDate={finalDate}
                        setInitialDate={setInitialDate}
                        setFinalDate={setFinalDate}
                        disabled={searching}
                      />
                    </Grid>
                  )}
                </Grid>
                <Grid container spacing={2} hidden={showFilters}>
                  <Grid item xs={isMobile700 ? 12 : isMobile900 && 6}>
                    <Button
                      style={
                        isMobile700 || isMobile900
                          ? { width: "100%", marginBottom: "0.75rem" }
                          : { marginBottom: "0rem" }
                      }
                      color="default"
                      variant="contained"
                      onClick={() => {
                        setTypeFailure("");
                        setSearchingFailures(true);
                      }}
                      disabled={searching || clearFilters}
                    >
                      {searching ? "Pesquisando..." : "Pesquisar"}
                    </Button>
                  </Grid>
                  <Grid
                    item
                    xs={isMobile700 ? 12 : isMobile900 && 6}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <ClearButton
                      fullWidth={true}
                      disabled={searching}
                      onClick={() => handleClearFilters()}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
        {tableData()}
      </Container>
      {Boolean(openFormDialog) && (
        <DialogMonitorDeTeares
          open
          formType={openFormDialog}
          typeProcessingList={typeProcessingList}
          onClose={() => {
            setSelectedReason(null);
            setOpenFormDialog(null);
          }}
          selectedReason={failureDetail}
          onUpdated={(e) => setHasUpdated(e)}
        />
      )}
    </>
  );
}
MonitorDeTeares.propTypes = {};
export default MonitorDeTeares;
